import RouteNavigator from "@mpa/toolbox/navigation/Navigator";
import Route from "@mpa/toolbox/navigation/Route";

import { StatefullUrl } from "../../action/Action";
import { getCurrentLocation, navigate, useLocationState } from "../../navigation/location";
import { rootNavigator } from "../RootNavigator/navigation";

export const authNavigator = rootNavigator.addNavigator(new RouteNavigator());
export const authIndexRoute = authNavigator.addRoute(new Route().setPath("/"));

export type AnonymousSignupStep = "explain" | "reveal" | "confirm" | "password";

export type IndexRouteState = {
    action: "login" | "signup" | null;
    method: "anonymous" | "email" | null;
    signup_anonymous: {
        step: AnonymousSignupStep | null;
        code: string | null;
    } | null;
};

const defaultIndexRouteState: IndexRouteState = {
    action: null,
    method: null,
    signup_anonymous: null,
};

export function getIndexLocation(state: IndexRouteState = defaultIndexRouteState) {
    return new StatefullUrl(getCurrentLocation(), state);
}

export function goToIndex(state: IndexRouteState) {
    const location = getIndexLocation(state);
    navigate(location.url, { state: location.state });
}

export function useIndexLocationState(): IndexRouteState {
    const state = useLocationState<IndexRouteState>();
    return {
        action: state?.action ?? null,
        method: state?.method ?? null,
        signup_anonymous: state?.signup_anonymous ?? null,
    };
}
